<template>
	<TheLogo/>
	<div class="header">
		<div class="container">
			<div class="header-container row">
				<div class="col-md-5 row ms-0 me-0 ps-0 pe-0" >
				</div>
				
				<div class="col-md-4 row ms-0 me-0 ps-0 pe-0 d-flex justify-content-center align-items-center" >
					<div class="col-md-10">
						<Dropdown :options="legalGroups" optionLabel="name" filter :filterFields="['name']" showClear :placeholder="isLegalGroupLoading ? ('Loading...') : 'Legal Group'" :loading="isLegalGroupLoading" v-model="filterLegalGroupModel" @change="onLegalGroupChange" v-if="!isRPKUser">
							<template #value="slotProps">
								<div v-if="slotProps.value" class="row ">
									<span class="col-md-12"></span>
									<span class="col-md-12">{{ slotProps.value.name + ' and Subsidiary Companies' }}</span>
								</div>
								<span v-else>
									{{ slotProps.placeholder }}
								</span>
							</template>

							<template #option="slotProps">
								<div class="row ">
									<span class="col-md-12">{{ slotProps.option.name + ' and Subsidiary Companies'}}</span>
								</div>
							</template>
						</Dropdown>
					</div>
				</div>
				
				<div class="col-md-3 row ms-0 me-0 ps-0 pe-0 d-flex justify-content-end">
					<div class="header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end" v-tooltip.bottom="'Home'">
						<SpeedDial class="speeddial" direction="down" showIcon="pi pi-home" hideIcon="pi pi-home" @click="home" />
					</div>
					
					<div class="header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end" v-tooltip.bottom="'Submission'" v-if="!isApprovalPortal && (isAdmin || isHQStaff)">
						<Button class="p-overlay-badge hidden-button-badge me-2 p-badge-danger" :badge="totalApprovalCount != null && totalApprovalCount != '' && totalApprovalCount != '0' ? totalApprovalCount : ''" />
						<SpeedDial class="speeddial" direction="down" showIcon="pi pi-check-square" hideIcon="pi pi-check-square" @click="approval" />
					</div>
					
					<div class="header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end" v-tooltip.bottom="'Admin'" v-if="!isAdminPortal && (isAdmin || isHQStaff)">
						<SpeedDial class="speeddial " direction="down" showIcon="pi pi-users" hideIcon="pi pi-users" @click="admin" />
					</div>
					
					<!-- <div class="header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end" v-tooltip.bottom="'Report'" v-if="!isReportPortal">
						<SpeedDial class="speeddial" direction="down" showIcon="pi pi-chart-bar" hideIcon="pi pi-chart-bar" @click="report" />
					</div> -->
					
					<div class="header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end" v-tooltip.bottom="'Audit Log'" v-if="!isAuditLogPortal && (isAdmin || isHQStaff)">
						<SpeedDial class="speeddial" direction="down" showIcon="pi pi-pencil" hideIcon="pi pi-pencil" @click="audit" />
					</div>
					
					<div class="header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end" v-tooltip.bottom="{value: 'Account', disabled: isAccountVisible}">
						<SpeedDial class="speeddial" :model="items" direction="down" showIcon="pi pi-user" hideIcon="pi pi-user" @show="showAccount" @hide="hideAccount" :tooltipOptions="{position: 'left'}" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store";
	import portalMixin from "@/mixin/portal";
	import roleMixin from "@/mixin/role";
	
	import approvalApi from "@/api/approval-api";
	import companyApi from "@/api/company-api";

	import TheLogo from "./TheLogo.vue";
	
	export default defineComponent({
		mixins: [portalMixin, roleMixin],
		components: {
			TheLogo,
		},
		data() {
			return {
				isAccountVisible: false,
				items:
					[
						{
							label: "Profile",
							icon: "pi pi-user-edit",
							command: () => {
								this.profile();
							}
						},
						{
							label: "Logout",
							icon: "pi pi-external-link",
							command: () => {
								this.logout();
							}
						}
					]
				,
				totalApprovalCount: store.getters.getTotalApprovalCount,
				legalGroups: (store.getters.getLegalGroups == null ? null : store.getters.getLegalGroups),
				filterLegalGroupModel: (store.getters.getFilterLegalGroupModel ==  null ? null as any : store.getters.getFilterLegalGroupModel),
				isLegalGroupLoading: false,
			}
		},
		watch: {
            filterLegalGroup(newValue: any) {
				this.loadApprovalTotalCount();
			}
        },
		computed: {
			filterLegalGroup() {
				return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel : null);
			}
        },
		mounted() {
			this.loadApprovalTotalCount();

			if (this.legalGroups == null) {
				this.isLegalGroupLoading = true;
				companyApi.companyLegalList({})
					.then(response => {
						this.legalGroups = response.data.listSet;
						store.state.legalGroups = this.legalGroups;
						this.isLegalGroupLoading = false;
					})
					.catch(error => {
						this.isLegalGroupLoading = false;
					});
			}
		},
		methods: {
			loadApprovalTotalCount() {
				if (this.isAdmin || this.isHQStaff) {
					approvalApi.approvalTotalCount({filterLegalGroupModel: {value: this.filterLegalGroup}})
						.then((response) => {
							if (response.data.count == null) {
								this.totalApprovalCount = '';
							}
							
							else {
								if (response.data.count > 9) {
									this.totalApprovalCount = '9+';
								}
								
								else {
									this.totalApprovalCount = response.data.count.toString();
								}
							}
							store.state.totalApprovalCount = this.totalApprovalCount;
						})
						.catch(error => {
							//
						});
				}
			},
			onLegalGroupChange(event: any) {
				this.filterLegalGroupModel = event.value;
				this.$store.dispatch('filterLegalGroupModelSession', this.filterLegalGroupModel);
			},
			admin() {
				this.$router.push(this.isHQStaff ? "/admin/user" : "/admin");
			},
			approval() {
				this.$router.push("/submission");
			},
			employee() {
				this.$router.push("/home");
			},
			report() {
				this.$router.push("/reporting");
			},
			audit() {
				this.$router.push("/audit");
			},
			showAccount() {
				this.isAccountVisible = true;
			},
			hideAccount() {
				this.isAccountVisible = false;
			},
			home() {
				this.$router.push("/home");
			},
			profile() {
				this.$router.push("/profile");
			},
			logout() {
				this.$store.dispatch("logout")
					.then(() => {
						this.$router.push("/login");
					})
					.catch(() => {
						this.$router.push("/login");
					})
			}
		},
	});
</script>